const FAQS = [
  {
    question: 'When is monetization expanding beyond the U.S.?',
    answer:
      'We are currently working on unlocking this option for our global creators and will have more to share in 2022.',
  },
  {
    question:
      'When do I know how much I’ll earn with each Ads by Anchor option?',
    answer:
      'Each option has a slightly different pricing model that will determine how much you earn. You will be shown the price for each option before you accept it.',
  },
  {
    question:
      "I'm not currently hosted on Anchor. Can I still use your monetization tools?",
    answer:
      'Your podcast must be hosted on Anchor to take advantage of Anchor’s monetization tools.',
  },
  {
    question: 'Will the ads play beyond Spotify?',
    answer:
      'Yes, Ads by Anchor can play on and beyond Spotify. Ads served to listeners on Spotify will be delivered via Spotify’s proprietary Streaming Ad Insertion technology, which enables the most precise and transparent podcast advertising in the industry.',
  },
  {
    question: 'Can I use multiple monetization tools at the same time?',
    answer:
      'Creators are free to choose how many ads, and which types (based on which they qualify for), to include in their episodes, to maximize their earning potential. However, we recommend that you not include ads in episodes for your paid subscribers.',
  },
  {
    question:
      'How will I know when I qualify for different Ads by Anchor options?',
    answer:
      "Check the 'Money' page on Anchor to see the different Ads by Anchor options and which you qualify to use.",
  },
];

export { FAQS };
